import React from 'react';

const ServerPagination = ({ 
    currentPage, 
    totalPages, 
    onPageChange, 
    totalCount,
    pageSize,
    showPageInfo = true 
}) => {
    const pageNumbers = [];
    const maxVisiblePages = 5;

    // Calculate start and end page numbers
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust start page if we're near the end
    if (endPage - startPage < maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }

    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    if (totalPages <= 1) return null;

    return (
        <nav className="container mx-auto p-6">
            <div className="flex items-center justify-between">
                {showPageInfo && (
                    <div className="text-sm text-gray-700">
                        Showing {((currentPage - 1) * pageSize) + 1} to {Math.min(currentPage * pageSize, totalCount)} of {totalCount} results
                    </div>
                )}
                <ul className="flex justify-center items-center gap-1">
                    <li>
                        <button
                            onClick={handlePrevious}
                            disabled={currentPage === 1}
                            className={`px-3 py-1 rounded ${
                                currentPage === 1
                                    ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                    : 'bg-gray-200 hover:bg-gray-300'
                            }`}
                        >
                            Previous
                        </button>
                    </li>
                    {startPage > 1 && (
                        <>
                            <li>
                                <button
                                    onClick={() => onPageChange(1)}
                                    className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
                                >
                                    1
                                </button>
                            </li>
                            {startPage > 2 && (
                                <li className="px-2">...</li>
                            )}
                        </>
                    )}
                    {pageNumbers.map(number => (
                        <li key={number}>
                            <button
                                onClick={() => onPageChange(number)}
                                className={`px-3 py-1 rounded ${
                                    currentPage === number
                                        ? 'font-bold bg-green-300'
                                        : 'bg-gray-200 hover:bg-gray-300'
                                }`}
                            >
                                {number}
                            </button>
                        </li>
                    ))}
                    {endPage < totalPages && (
                        <>
                            {endPage < totalPages - 1 && (
                                <li className="px-2">...</li>
                            )}
                            <li>
                                <button
                                    onClick={() => onPageChange(totalPages)}
                                    className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
                                >
                                    {totalPages}
                                </button>
                            </li>
                        </>
                    )}
                    <li>
                        <button
                            onClick={handleNext}
                            disabled={currentPage === totalPages}
                            className={`px-3 py-1 rounded ${
                                currentPage === totalPages
                                    ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                    : 'bg-gray-200 hover:bg-gray-300'
                            }`}
                        >
                            Next
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default ServerPagination;

